module.exports = __webpack_public_path__ + "static/bordeaux-developer-experience-aadc2d7d3c0dbc1fb5b1716c6ba2a600.png";